<template>
  <div class="modal modal-sla-report-history fade fixed-end" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h2 class="modal-title">Report Send History</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <p v-if="!sends.length" class="text-muted small mb-0">
            No reports have been sent for this period.
          </p>

          <div v-else class="rh-list">
            <div v-for="send in sends" :key="send.id" class="rh-item">
              <div class="rh-item-icon">
                <i class="fa fa-paper-plane text-success"></i>
              </div>
              <div class="rh-item-body">
                <div class="rh-item-to">{{ send.sent_to }}</div>
                <div class="rh-item-meta">
                  <span class="rh-item-date">
                    <i class="fa fa-clock-o me-1"></i>{{ send.sent_at | moment('D MMM YYYY, h:mm A') }}
                  </span>
                  <span v-if="send.sent_by" class="rh-item-by">
                    <i class="fa fa-user-o me-1"></i>{{ send.sent_by }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { CModal } from '@chameleon/chameleon-vue'

export default {
  extends: CModal,

  props: {
    sends: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.rh-list {
  display: flex;
  flex-direction: column;
}

.rh-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f0f0f0;
}

.rh-item:last-child {
  border-bottom: none;
}

.rh-item-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: #f0fdf4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  margin-top: 2px;
}

.rh-item-body {
  flex: 1;
  min-width: 0;
}

.rh-item-to {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  word-break: break-all;
  margin-bottom: 4px;
}

.rh-item-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.rh-item-date,
.rh-item-by {
  font-size: 12px;
  color: #6b7280;
}
</style>
